import React from 'react'
// import Topnavbar from '../header/Topnavbar'
import Footer1 from '../footer/Footer1'
import Topnavbardata from '../header/Topnavbar1'

const PrivacyandPolicy = () => {
  return (
    <div>
     <Topnavbardata/>
   
    <main class="main">
        
    <section class="dark-background header-section text-center" style={{marginBottom:"-60px"}}>
        <h1 class="mt-xl-5">Privacy Policy</h1>
        <p>Effective Date: <strong>January 1, 2025</strong></p>
    </section>
    {/* <!-- Terms & Conditions Section --> */}
    <section class="container">
        <div class="row">
            <div class="col-lg-10 mx-auto">
                <h5>1. Introduction</h5>
                <p>Welcome to <strong>TechBiz SoftwareSolutions</strong>. We are committed to protecting your privacy. This policy explains how we collect, use, and protect your information when you use our website (<a href="https://techbizsoftwaresolutions.com/" target="_blank">techbizsoftwaresolutions.com</a>) and services.</p>

                <h5>2. Information We Collect</h5>
                <ul>
                    <li><strong>Personal Information:</strong> Name, email address, phone number, company name, and other details you provide when contacting us or using our services.</li>
                    <li><strong>Technical Data:</strong> Your IP address, browser type, device information, and pages visited to improve user experience and website functionality.</li>
                    <li><strong>Cookies and Tracking Technologies:</strong> We use cookies to enhance your experience and analyze site traffic. You can manage cookie preferences in your browser settings.</li>
                </ul>

                <h5>3. How We Use Your Information</h5>
                <p>We use your information for the following purposes:</p>
                <ul>
                    <li>To provide and improve our services.</li>
                    <li>To personalize your experience.</li>
                    <li>To send important updates, newsletters, and promotional content (you can opt out at any time).</li>
                    <li>To analyze website performance and enhance security.</li>
                    <li>To comply with legal and regulatory obligations.</li>
                </ul>

                <h5>4. Data Protection &amp; Security</h5>
                <p>We implement security measures to protect your personal data from unauthorized access, disclosure, or misuse. However, no method of transmission over the internet is completely secure.</p>

                <h5>5. Sharing Your Data</h5>
                <ul>
                    <li>We do not sell or rent your data.</li>
                    {/* <!-- <li>We may share data with trusted third-party service providers (e.g., payment processors).</li> --> */}
                    {/* <!-- <li>Legal requirements may require us to share data with law enforcement agencies.</li> --> */}
                </ul>

                <h5>6. Your Rights</h5>
                <ul>
                    <li>You have the right to access, update, or delete your data.</li>
                    <li>You can opt-out of marketing communications.</li>
                    <li>To request data changes, email us at <a href="mailto:support@techbizsoftwaresolutions.com">support@techbizsoftwaresolutions.com</a>.</li>
                </ul>

                <h5>7. Cookies &amp; Tracking</h5>
                <p>We use cookies to enhance your experience. You can disable cookies in your browser settings.</p>

                <h5>8. Third-Party Links</h5>
                <p>Our website may contain links to third-party websites. We are not responsible for their privacy policies or content. We encourage you to review their policies before providing any personal information.</p>

                <h5>9. Policy Updates</h5>
                <p>We may update this policy periodically. Any changes will be posted on this page with an updated effective date. Your continued use of our services implies acceptance of the revised policy.</p>

                <h5>10. Contact Information</h5>
                <p>If you have any questions about our Privacy Policy, contact us:</p>
                <ul>
                    <li>Email: <a href="mailto:support@techbizsoftwaresolutions.com">support@techbizsoftwaresolutions.com</a></li>
                    <li>Phone: +91 84335 53300 / +91 81040 43108</li>
                    <li>Address: Airoli, Navi Mumbai,Maharashtra- 400708, India</li>
                </ul>
            </div>
        </div>
    </section>
    

  </main>
  <Footer1/>
  </div>
  )
}

export default PrivacyandPolicy
